/* norgira-home-product-swipe-2026-08-29 */
(() => {
  const mobile = matchMedia('(max-width: 749px)');
  const selector = 'main .norgira-new-arrivals-grid__media, main .norgira-white-bg-grid__media, main product-recommendations .norgira-pdp-related-home-card__media';
  const installStyle = () => {
    if (document.getElementById('norgira-home-product-swipe-2026-08-29-style')) return;
    const style = document.createElement('style'); style.id = 'norgira-home-product-swipe-2026-08-29-style';
    style.textContent = '@media(max-width:749px){' +
      selector + '{display:block!important;overflow-x:auto!important;overflow-y:hidden!important;scroll-snap-type:x mandatory!important;scrollbar-width:none!important;-webkit-overflow-scrolling:touch!important;touch-action:pan-x pan-y!important}' +
      selector + '::-webkit-scrollbar{display:none}' +
      '.norgira-home-swipe-track{display:flex!important;width:max-content!important;height:100%!important}' +
      '.norgira-home-swipe-track>img{position:relative!important;inset:auto!important;display:block!important;flex:0 0 var(--norgira-home-swipe-width)!important;width:var(--norgira-home-swipe-width)!important;max-width:none!important;height:100%!important;object-fit:contain!important;opacity:1!important;transform:none!important;scroll-snap-align:start!important;pointer-events:none!important}' +
    '}'; document.head.append(style);
  };
  const setup = async (media) => {
    if (!mobile.matches || media.dataset.norgiraHomeSwipeReady) return;
    const handle = (media.getAttribute('href') || '').split('/products/')[1]?.split(/[?#]/)[0];
    if (!handle) return;
    media.dataset.norgiraHomeSwipeReady = 'pending';
    try {
      const response = await fetch('/products/' + handle + '.js', { credentials: 'same-origin' });
      const product = response.ok ? await response.json() : null;
      const images = (product?.images || []).map((image) => typeof image === 'string' ? image : image?.src).filter(Boolean);
      if (images.length < 2) { media.dataset.norgiraHomeSwipeReady = 'single'; return; }
      const track = document.createElement('span'); track.className = 'norgira-home-swipe-track';
      images.forEach((src, index) => { const image = document.createElement('img'); image.src = src; image.alt = index === 0 ? (media.getAttribute('aria-label') || product.title || '') : ''; image.loading = index ? 'lazy' : 'eager'; track.append(image); });
      media.replaceChildren(track);
      const setWidth = () => media.style.setProperty('--norgira-home-swipe-width', Math.round(media.getBoundingClientRect().width) + 'px');
      setWidth(); new ResizeObserver(setWidth).observe(media);
      let startX = 0; let moved = false;
      media.addEventListener('pointerdown', (event) => { startX = event.clientX; moved = false; }, { passive: true });
      media.addEventListener('pointermove', (event) => { if (Math.abs(event.clientX - startX) > 8) moved = true; }, { passive: true });
      media.addEventListener('click', (event) => { if (moved) { event.preventDefault(); event.stopPropagation(); } }, true);
      media.dataset.norgiraHomeSwipeReady = 'true';
    } catch { media.dataset.norgiraHomeSwipeReady = 'error'; }
  };
  const start = () => {
    if (!mobile.matches) return;
    installStyle();
    const scan = (root = document) => root.querySelectorAll?.(selector).forEach(setup);
    scan();
    new MutationObserver((records) => records.forEach((record) => record.addedNodes.forEach((node) => {
      if (node.nodeType !== 1) return;
      if (node.matches?.(selector)) setup(node);
      scan(node);
    }))).observe(document.documentElement, { childList: true, subtree: true });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start, { once: true }) : start();
})();